function filterPublication(){
    jQuery(function($){
        $(document).on('input','#filter-publication',function(){
            var filter = $(this);
            $.ajax({
                url:filter.attr('action'), 
                data:filter.serialize(), 
                type:filter.attr('method'), 
                dataType : "json",
                beforeSend:function(xhr){ 
                },
                success:function(data){
                    $('#response-publication').html(data['inputs'] + data['cards']);
                    var howmuchFiltred = $('#how-much-filtred').val();
                    $('#howmuch').val(howmuchFiltred);
                    lazyLoadInstance.update();
                }
            });
            return false;
        });
        $(window).scroll(function(){
            var footerHeight = $('footer.footer').height() / 2;
            var elHeight = $(document).height() - $(window).height() - footerHeight;
            var curScroll = $(window).scrollTop();
            if (curScroll > elHeight){
                var filters = $('#filter-publication');
                var getElementCur = $('#response-publication').find('#offset-cur');
                var curVal = parseInt(getElementCur.val());
                var howmuchFiltredt = $('#how-much-filtred').val();
                if(curVal <= howmuchFiltredt){
                    $('#filter-publication').find('#offset-response').val(curVal+9);
                    setTimeout(function(){
                        $.ajax({
                            url:filters.attr('action'), 
                            data:filters.serialize(), 
                            type:filters.attr('method'), 
                            dataType : "json",
                            beforeSend:function(xhr){
                            },
                            success:function(data){
                                $('#response-publication').html(data['inputs'] + data['cards']);
                                lazyLoadInstance.update();
                            }
                        });
                    },100)
                }
            }
            return false;
        });
        $('#filter-publication').find('#offset-response').val(9);
    });
}
module.exports = filterPublication;